/**
 * Display defaults — live amounts/deadline come from GET /api/auction (authoritative).
 */
import { config } from '../../config/config';

export const AUCTION_CONFIG = {
  eventTitle: 'World Cup Final',
  eventEyebrow: '2026 FIFA World Cup Final · MetLife Stadium',
  venue: 'New York / New Jersey (MetLife Stadium)',
  eventDateLabel: 'July 19, 2026',
  matchup: 'FIFA World Cup 2026™ Final',
  packageName: 'All Inclusive Hospitality',
  packageType: 'Hospitality',
  section: '211',
  row: '11',
  qtyLabel: '1 Guest',
  experienceTitle: 'The All Inclusive Hospitality Experience: World Cup Final',
  experienceIntro:
    'Looking for the ultimate way to experience the FIFA World Cup 2026™ Final? The All Inclusive Hospitality package delivers a premium, all-inclusive matchday experience from start to finish.',
  inclusions: [
    {
      title: 'Prime Midfield Seat',
      detail:
        'Premium sideline seating located in Section 211, Row 11—offering a perfect, elevated view of the entire pitch.',
    },
    {
      title: 'Extended Lounge Access',
      detail:
        'Exclusive access to the high-end shared lounge starting 4 hours before kickoff and staying open for 2 hours after the trophy lift—giving you plenty of time to skip the crowds and enjoy the pre-match atmosphere.',
    },
    {
      title: 'Upscale Dining',
      detail:
        'A chef-driven culinary menu featuring gourmet stations and premium, locally-inspired dishes.',
    },
    {
      title: 'Premium Open Bar',
      detail:
        'Fully inclusive premium spirits, wines, beers, and soft drinks available throughout the entire event.',
    },
    {
      title: 'Dietary Accommodations',
      detail:
        'Diverse menu options that seamlessly cater to vegetarian, vegan, gluten-free, and halal preferences.',
    },
  ],
  /** Fallback display until GET /api/auction loads (DB is authoritative). */
  startingBidUsd: 25050,
  reserveUsd: 25000,
  minIncrementUsd: 50,
  softCloseExtendMinutes: 0,
} as const;

/** Same host resolution as other admin APIs (env → config fallback by REACT_APP_ENVIRONMENT). */
export const getAuctionApiBase = () =>
  (
    process.env.REACT_APP_NODE_API_URL ||
    config.node_api_url ||
    (typeof window !== 'undefined' && window.location.hostname === 'localhost'
      ? 'http://localhost:4000'
      : '')
  ).replace(/\/+$/, '');
